<template>
  <div class="iconWrapper">
    <i class="icon bi bi-arrow-repeat" />
  </div>
  <div class="title">Nous procédons à quelques vérifications techniques</div>
  <div class="text">Veuillez patienter quelques instants ...</div>
</template>

<style lang="scss" scoped>
.iconWrapper {
  width: 64px;
  height: 64px;

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  font-size: 36px;

  background-color: #1FA969;

  .icon {
    animation: spinner 1.5s linear infinite;

    @keyframes spinner {
      to {
        transform: rotate(360deg);
      }
    }
  }
}

.title {
  font-size: 32px;
  font-weight: 700;
}

.text {
  font-size: 18px;
}
</style>